import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import '../style/Footer.less';
import LanguageSelector from './LanguageSelector';

function Footer() {
    const [t] = useTranslation();

    return (
        <footer>
            <LanguageSelector/>
            <Link to={{pathname: "https://alpenhunde.de/impressum/"}} target="_blank">{t('Footer.IMPRINT')}</Link>|
            <Link to={{pathname: "https://alpenhunde.de/datenschutzerklaerung/"}} target="_blank">{t('Footer.PRIVACY')}</Link>|
            <Link to={{pathname: "https://alpenhunde.de/impressum/"}} target="_blank">{t('Footer.CONTACT')}</Link>|
        </footer>
    );
}

export default Footer;
